import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}, user={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            variableObject[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = parsedParameters['variableObject'];
        let resolvedParams = parsedParameters['accumulator'];

        let filter = {
            name : resolvedParams['name'] || '',
            projectId : resolvedParams['projectId'] || '',
            categoryId : resolvedParams['categoryId'] || '',
            categoryName : resolvedParams['categoryName'] || '',
            status : resolvedParams['status'],
            uniqueProjectKey : resolvedParams['uniqueProjectKey'] || '',
            projectStartDate : resolvedParams['projectStartDate'] || 0,
            projectEndDate : resolvedParams['projectEndDate'] || 0,
            createdDate : resolvedParams['createdDate'] || 0,
            editDate : resolvedParams['editDate'] || 0,
            customerName : resolvedParams['customerName'] || '',
            active : resolvedParams['active'],
            companyId,
            functionGenerated : true,
            queryEnvironment : appEnvironment
        }

        let sort = {};
        if(
            resolvedParams['sortByCreatedDate'] && 
            (typeof resolvedParams['sortByCreatedDate'] === 'string')
        ){
            sort['createdDate'] = resolvedParams['sortByCreatedDate'].toLowerCase().startsWith('asc') ? 1 : -1
        }
        if(
            resolvedParams['sortByEditDate'] && 
            (typeof resolvedParams['sortByEditDate'] === 'string')
        ){
            sort['editDate'] = resolvedParams['sortByEditDate'].toLowerCase().startsWith('asc') ? 1 : -1
        }
        if(
            resolvedParams['sortByProjectName'] && 
            (typeof resolvedParams['sortByProjectName'] === 'string')
        ){
            sort['name'] = resolvedParams['sortByProjectName'].toLowerCase().startsWith('asc') ? 1 : -1
        }
        if(
            resolvedParams['sortByProjectStartDate'] && 
            (typeof resolvedParams['sortByProjectStartDate'] === 'string')
        ){
            sort['projectStartDate'] = resolvedParams['sortByProjectStartDate'].toLowerCase().startsWith('asc') ? 1 : -1
        }
        if(
            resolvedParams['sortByProjectEndDate'] && 
            (typeof resolvedParams['sortByProjectEndDate'] === 'string')
        ){
            sort['projectEndDate'] = resolvedParams['sortByProjectEndDate'].toLowerCase().startsWith('asc') ? 1 : -1
        }

        let encryptedPayload = encryptDecrypt(
            JSON.stringify({
                payload : {
                    filter,
                    sort,
                    limit : typeof resolvedParams['limit'] === 'number' ? resolvedParams['limit'] : 0,
                    skip : typeof resolvedParams['skip'] === 'number' ? resolvedParams['skip'] : 0,
                },
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        let encryptedAccessHeader = '', clientEncryptedApiHeader='';
        if(resolvedParams['X-API-KEY']){
            clientEncryptedApiHeader = encryptDecrypt(
                JSON.stringify({
                    payload : {
                        'X-API-KEY' : resolvedParams['X-API-KEY'],
                        companyId,
                        queryKey : `${Math.random()}${Math.random()}${Math.random()}${new Date().getTime()}`,
                        environment : appEnvironment
                    },
                    expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                }),
                true
            );
        }else{
            if(user && user.isAuthenticated){
                encryptedAccessHeader = encryptDecrypt(
                    JSON.stringify({
                        payload : {
                            assetOwnerCompanyId : companyId,
                            companyId : user['companyId'],
                            email : user['email'],
                            subscriptionId : user['subscriptionId'],
                            subscriptionServiceId : user['subscriptionServiceId'],
                            environment : appEnvironment,
                            _id : user['_id'],
                            userId : user['_id'],
                            isInternal : (user['subscriberType'] === 'internal') || user['isInternal'] ? true : false,
                            isSystemUser : user['isSystemUser'] ? true : false
                        },
                        expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
                    }),
                    true
                );
            }
        }

        let response = await fetch(
            `${config.devServerProxy}/api/inhouzproject/project/getprojects`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'clientEncryptedAccessHeader' : encryptedAccessHeader,
                    'X-CE-API-KEY' : clientEncryptedApiHeader
                },
                credentials : 'omit',
                body : JSON.stringify({
                    encryptedPayload
                })
            }
        )
        .then(resp => resp.json())
        .catch((error) => {
            return {
                error : {
                    message : error.message
                }
            }
        });

        variableCopy[variableName] = response;
        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/getInhouzProjectsParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}